export const iconFontAwesomeDevicesHardwareMobileScreenButton = (
	<i className="fa-solid fa-mobile-screen-button"></i>
);
